import React from 'react';
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/index.css';
import HeaderItemBrand from './HeaderItemBrand';
import HeaderItemBrandSmall from './HeaderItemBrandSmall';
var selfStyles = require('./styles.scss');
var PageHeader = function (props) { return (React.createElement(Layout.Header, { className: selfStyles.header },
    React.createElement(HeaderItemBrand, null),
    "      ",
    React.createElement(HeaderItemBrandSmall, null),
    " ")); };
export default PageHeader;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/index.tsx
// module id = 631
// module chunks = 0